import { enUS, it, ro, es, fr, de } from 'date-fns/locale';

export function createPageUrl(pageName: string) {
    return '/' + pageName.replace(/ /g, '-');
}

const localeMap: Record<string, Locale> = {
  en: enUS,
  it: it,
  ro: ro,
  es: es,
  fr: fr,
  de: de,
};

export function getDateLocale(language: string) {
  return localeMap[language] || it;
}
